<div class="container">
  
  
  <div class="pix-container" [class.payment-with-pix]="permitirPagamentoPix">
    <div class="emotion" [class]="emotionImage"></div>
    <div>
      <h2 class="mat-h1">Aqui está a sua parcela para pagamento!</h2>
      <button
        *ngIf="permitirPagamentoPix"
        mat-raised-button
        class="botao-pix"
        color="primary" 
        (click)="pagarComPix()">
        <span>Pagar Com PIX</span>
        <mat-icon class="pix-icon">
          <img src="/assets/images/logo-pix.svg" width="42px" height="42px" alt="Icone pagar com pix">
        </mat-icon>
      </button>
    </div>
  </div>

  <div *ngIf="showAlert && !isRenegociacao" class="alert-warning">
    <mat-icon class="warning-icon">warning</mat-icon>
    <p class="mat-body">
      O pagamento deve ser efetuado no próximo dia útil para registro da linha digitável/código de barras junto à instituição bancária.
    </p>
  </div>

  <div *ngIf="!clientePerfil?.celular || !clientePerfil?.email" class="alert-warning">
    <mat-icon class="warning-icon material-symbols-outlined">error</mat-icon>
    <p class="mat-body">
      Por favor, adicione o seu número de celular e/ou e-mail na pagina de <a [routerLink]="'/portal/perfil'" >Perfil</a>.
    </p>
  </div>

  <div class="boleto-container">
    <p class="mat-body">Use a linha digitável/código de barras para realizar seu pagamento na rede bancária, internet banking ou lotéricas!</p>
    
    <div class="valores-boleto">
      <p class="mat-body-strong codigo">
        Linha Digitável: <br>
        {{dadosBoleto?.codigo}}
      </p>
      
      <div class="valores-boleto-linha">
        <p class="mat-body-strong codigo">
          Vencimento:
          {{convertToDatabaseDate(dadosBoleto?.dataVencimento)}}
        </p>
    
        <p class="mat-body-strong codigo">
          Valor da Parcela:
          {{dadosBoleto?.valorDocumento | currency:'BRL'}}
        </p>
      </div>
    </div>

    <div class="actions">
      <button 
        color="primary"
        (click)="enviarLinhaDigitavelEmail()"
        [disabled]="disabledEmail || !clientePerfil?.email"
        data-context="renegociacao"
        data-collect="enviar por email" 
        mat-raised-button>
        <span>Enviar por Email</span>
        <mat-icon class="icon">email</mat-icon>
      </button>

      <button
        (click)="enviarLinhaDigitavelSms()"
        color="primary"
        [disabled]="disabledSms || !clientePerfil?.celular"
        data-context="renegociacao" 
        data-collect="enviar por sms" 
        mat-raised-button>
        <span>Enviar por SMS</span>
        <mat-icon class="icon">textsms</mat-icon>
      </button>

      <button 
        color="primary" 
        mat-raised-button
        [disabled]="copiado"
        data-context="renegociacao" 
        data-collect="copiar codigo"
        (click)="copiarLinhaDigitavel()"
        [cdkCopyToClipboard]="dadosBoleto?.codigo">
        <span *ngIf="!copiado">Copiar</span>
        <span *ngIf="copiado">Copiado</span>
        <mat-icon class="copy-icon icon">file_copy</mat-icon>
      </button>

      <button 
        *ngIf="showDownloadButton"
        color="primary" 
        mat-raised-button
        data-context="renegociacao" 
        data-collect="baixar boleto"
        [disabled]="baixado"
        (click)="baixarBoleto()">
        <span>Download</span>
        <mat-icon class="copy-icon icon">get_app</mat-icon>
      </button>
    </div>
  </div>


</div>
